import { mutatorAction } from 'satcheljs';
import { mailListItemAnimationStore } from '../store/Store';
import { cancelAllRowAnimationsForAnimation } from '../utils/cancelAllRowAnimationsForAnimation';

export const removeCompletedAnimations = (): void => {
    const { completedAnimations } = mailListItemAnimationStore();
    for (const animation of completedAnimations) {
        cancelAllRowAnimationsForAnimation(animation);
    }
    removeCompletedAnimationsMutator();
};

const removeCompletedAnimationsMutator: () => void = mutatorAction(
    'removeCompletedAnimations',
    (): void => {
        // Skip resetting already-empty observable arrays to avoid triggering unnecessary MobX reactions
        if (
            !mailListItemAnimationStore().completedAnimations ||
            mailListItemAnimationStore().completedAnimations.length > 0
        ) {
            mailListItemAnimationStore().completedAnimations = [];
        }
    }
);
